import commonConfig from '../../config/common.json';
function getStaticConfig(env = 'development') {
    const envConfig = require(`../../config/${env}.json`);
    return {
        ...commonConfig,
        ...envConfig,
    };
}
export default getStaticConfig;
